import type { StateFieldValue } from '../../tri-shared/types/tierii-state-fields.ts';
import { EMAIL_PATTERN } from '../services/email.ts';

// Tier2 Submit 2025 Rev 1 validation details, IDs 116, 144-146, 155 and 166.
// Patterns describe identifiers, not numbers: retain leading zeros where allowed.
// native-validation-2025.json records the vendor's result for each rule.
export const STATE_VALUE_RULES: Record<string, { pattern: string; message: string }> = {
  'AL:text05': {
    pattern: '^[1-9][0-9]{0,5}$',
    message: 'Master ID Number must be one to six digits and cannot start with zero.',
  },
  'TX:text01': { pattern: '^[0-9]{5,6}$', message: 'TXT2 Number must be five or six digits.' },
  'TX:text02': { pattern: '^RN[0-9]{9}$', message: 'TCEQ Regulated Entity Number must be RN followed by nine digits.' },
  'TX:text04': { pattern: '^CN[0-9]{9}$', message: 'TCEQ Customer Number must be CN followed by nine digits.' },
  'HI:text07': {
    pattern: '^[1-9][0-9]*$',
    message: 'Hawaii Facility ID Number must be a whole number greater than zero, without leading zeros.',
  },
  'AL:text06': { pattern: EMAIL_PATTERN, message: 'Enter a valid email address for proof of receipt.' },
  'ID:text01': { pattern: EMAIL_PATTERN, message: 'Enter a valid facility email address.' },
  'NH:text01': { pattern: EMAIL_PATTERN, message: 'Enter a valid monitored email address.' },
};
export function stateValueIssue(state: string, field: string, value: StateFieldValue): string | null {
  if (value === null || (typeof value === 'string' && !value.trim())) return null;
  const rule = STATE_VALUE_RULES[state + ':' + field];
  if (rule && (typeof value !== 'string' || !new RegExp(rule.pattern).test(value.trim()))) return rule.message;
  if (state === 'NM' && field === 'number02' && (typeof value !== 'number' || !Number.isInteger(value) || value <= 0))
    return 'Number of facilities must be a whole number greater than zero; leave it blank if unknown.';
  return null;
}
